import { Box, CircularProgress, Typography } from '@mui/material';

export const LoadingSpinner = ({ message = '' }) => (
  <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={300} gap={2}>
    <CircularProgress size={36} />
    {message && <Typography variant="body2" color="text.secondary">{message}</Typography>}
  </Box>
);
